export function getDataProfile(state) {
    return state.data_profile;
  }